/* This component UPDATES one entry in the historys collection in MongoDB. This component uses the
   GuestBioHistoryEntryReadComponent component to showw the items    available for UPDATE.
   This compoent should allow for addition and deletion of any entry in the selected history entry.
   HistoryDelete should only be used to delete an entire history entry in MongoDB. 
   
   entryId:    the _id of one of the entries in the entries array []
   entryType:  one of 4 items from the radio buttons, bullet, link, photo, text
   id:         the MongoDB _id for the History Entry in the histories collection
   
*/

import React, { useEffect, useRef, useState }   from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import Button                                   from '@material-ui/core/Button'
import { CLIENT_PUBLIC_TOKEN }                  from '../config.js'
import { getEntry }                             from '../Helpers/index.js'
import Grid                                     from '@material-ui/core/Grid'
import GuestBioHistoryEntryReadComponent        from './GuestBioHistoryEntryReadComponent.js'
import HistoryTitleReadComponent                from './HistoryTitleReadComponent.js'
import { node_server }                          from '../Helpers/index.js'
import Typography                               from '@material-ui/core/Typography'
import TextareaAutosize                         from '@material-ui/core/TextareaAutosize'
import TextField                                from '@material-ui/core/TextField'

const HistoryUpdateComponent = () => {

   const [ aChangeWasMade,                      setAChangeWasMade ]  =  useState(false)
   const [ entries,                             setEntries        ]  =  useState([])
   const   myEntriesRef                                              =  useRef(entries);
   const [ entry,                               setEntry          ]  =  useState('')
   const [ entryId,                             setEntryId        ]  =  useState('')
   const [ entryType,                           setEntryType      ]  =  useState('')
   const [ historyEntry,                        setHistoryEntry   ]  =  useState({})
   const [ id,                                  setId             ]  =  useState('')
   const [ linkCaption,                         setLinkCaption    ]  =  useState('')
   const [ linkId,                              setLinkId         ]  =  useState('')
   const [ photoId,                             setPhotoId        ]  =  useState('')
   const [ singleEntry,                         setSingleEntry    ]  =  useState({})
   const [ title,                               setTitle          ]  =  useState('')
   const [ width,                               setWidth          ]  =  useState(0)

   // Keep the ref in sync whenever state updates
   useEffect(() => {
      myEntriesRef.current = entries;
   }, [entries]);

   const handleBulletTextChange = (e) => {
      setSingleEntry(e.target.value)
   }

   /* This takes a click event and records the _id of the entire History Entry from the MongoDB histories collection */
   const handleClick = (id) => {
      setId(id)
      console.log('History Update Component got back this id from HistoryTitles', id)
   }

   /* This takes a click event on a text or bullet entry and returns the _id of that individual entry */
   const handleSelect = (entryId) => {
      console.log('History Update Component, this is the id of the entry you clicked on', entryId)
      if (id === 'title') {
         setEntryType('title')
      }
      else {
         console.log('You clicked on a text or bullet entry, the entry id is', entryId)
         setEntryType('entry')
         setEntryId(entryId)
         setSingleEntry(getEntry(myEntriesRef.current, entryId))
      }
   }
   
   const handleTitleChange = (e) => {
      setTitle(e.target.value)
      setAChangeWasMade(true)
   }
   
   const saveTitle = () => {
      const tempHistoryEntry = historyEntry
      tempHistoryEntry.title = title
      setHistoryEntry(tempHistoryEntry)
      console.log('New History Entry Title is', historyEntry.title)
   }
   
   const handleSubmit = () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.put(node_server + 'history', {
         entry,
         entryType,
         id,
         photoId,
         title,
         width,
         link: {
            id: linkId,
            caption: linkCaption,
            collectionName: 'guestBio',
            link: ''
         }
      })
      .then( res => res.data )
      .then( data => {
         console.log('History Update Component PUT data is', data)
      } )
      .catch( (error) => {
         console.error(error)
      } )
   }
   
   useEffect( () => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      if ( id !== '' ) {
         axios.get(node_server + `history/${id}`)
         .then( res => res.data )
         .then( data => {
            if (data.msg === 'good_operation') {
               setHistoryEntry(data.history)
               setEntries(data.history.entries)
               setTitle(data.history.title)
            }
            else {
               throw new Error('bad_operation_get_h4')
            }
         } )
         .catch( (error) => {
            console.error(error)
         } )
      }
   }, [id] )
   
   
   return (
      <Box style={{ marginTop: '6rem', marginBottom: '1rem', padding: '2rem' }} >
         <Grid>
            <Typography variant='h4'>
               History Entry Update Page
            </Typography>
         </Grid>
         <Grid>
            { id === '' ? <HistoryTitleReadComponent handleClick={handleClick} /> : <GuestBioHistoryEntryReadComponent entry={historyEntry} handleSelect={handleSelect} /> }
         </Grid>
         
         {/*  */}
         {entryId === '' && entryType === 'title'
            ?
               <Grid>
                  <Grid>
                     <TextField value={title} variant='outlined' style={{width: '90%'}} onChange={handleTitleChange} />
                  </Grid>
                  <Grid item xs={2} style={{ marginTop: '1rem' }}>
                     <Button variant='contained' color='primary' onClick={saveTitle}>Save</Button>
                  </Grid>
               </Grid>
            :
               null
         }

         {entryId !== '' && ['bullet', 'text'].includes(entryType)
            ?
               <Grid>
                  <Grid>
                     <TextareaAutosize value={singleEntry} variant='outlined' style={{width: '90%'}} onChange={handleBulletTextChange} />
                  </Grid>
                  <Grid item xs={2} style={{ marginTop: '1rem' }}>
                     <Button variant='contained' color='primary' onClick={saveTitle}>Save</Button>
                  </Grid>
               </Grid>
            :
               null
         }

         {aChangeWasMade
            ?
               <Grid item xs={2} style={{ marginTop: '1rem' }}>
                  <Button data-testid='history-create-submit' variant='contained' color='primary' onClick={handleSubmit}>Submit</Button>
               </Grid>
            :
               <Grid item xs={2} style={{ marginTop: '1rem' }}>
                  <Button variant='contained' color='primary' disabled>Submit</Button>
               </Grid>
         }
      </Box>
   )
}

export default HistoryUpdateComponent
